import { useEffect, useRef } from 'react'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'

import { WEDDING_DATE } from 'resources/constants'
import { venue1, venue2, venue3 } from 'resources/images'

import SectionTitle from 'components/SectionTitle'

// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import mapboxgl from '!mapbox-gl'

import {
	VenueContainer,
	VenueImage,
	VenueDetailsContainer,
	VenueDetails,
	DetailItem,
	DetailIconContainer,
	DetailIcon,
	DetailLineContainer,
	DetailLine,
	DetailText,
	MapMarker,
	MapMarkerIcon,
	CarouselIndicator,
	VenueCarousel,
	VenueWrapper,
} from './styles'

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN

const VENUE_LOCATION = {
	lat: -5.9495659,
	lng: -35.1800251,
}
const MAP_CENTER = VENUE_LOCATION

const IMAGE_URLS = [venue1, venue2, venue3]

function Venue() {
	const { i18n, t } = useTranslation()

	const mapContainer = useRef(null)
	const map = useRef(null)
	const marker = useRef(null)

	useEffect(() => {
		if (map.current) {
			return
		}

		// Create map
		map.current = new mapboxgl.Map({
			container: mapContainer.current,
			style: 'mapbox://styles/mapbox/light-v10?optimize=true',
			center: [MAP_CENTER.lng, MAP_CENTER.lat],
			zoom: 15,
			cooperativeGestures: true,
			testMode: true,
		})

		// Add zoom and rotation controls to the map.
		const nav = new mapboxgl.NavigationControl()
		map.current.addControl(nav, 'top-left')

		// Add marker
		new mapboxgl.Marker({ element: marker.current, draggable: false })
			.setLngLat([VENUE_LOCATION.lng, VENUE_LOCATION.lat])
			.addTo(map.current)
	}, [])

	return (
		<VenueWrapper id="venue">
			<div className="container">
				<SectionTitle>{t('Cerimônia e Recepção')}</SectionTitle>
				<VenueContainer>
					<VenueCarousel
						showArrows
						autoPlay
						infiniteLoop
						stopOnHover
						swipeable
						emulateTouch
						renderThumbs={() => null}
						renderArrowPrev={() => null}
						renderArrowNext={() => null}
						showStatus={false}
						renderIndicator={(onClickHandler, isSelected) => (
							<CarouselIndicator
								onClick={onClickHandler}
								selected={isSelected}
							/>
						)}
					>
						{IMAGE_URLS.map((url) => (
							<VenueImage key={url} src={url} alt="" />
						))}
					</VenueCarousel>
					<VenueDetailsContainer>
						<VenueDetails>
							<DetailItem>
								<DetailIconContainer>
									<DetailIcon>
										<i className="fa-solid fa-calendar-day" />
									</DetailIcon>
									<DetailLineContainer>
										<DetailLine>
											<line x1="50%" x2="50%" y1="1" y2="100%" />
										</DetailLine>
									</DetailLineContainer>
								</DetailIconContainer>
								<DetailText>
									<h3>{t('Data')}</h3>
									<p>
										{WEDDING_DATE.setLocale(i18n.language).toLocaleString(
											DateTime.DATE_MED_WITH_WEEKDAY,
										)}
									</p>
								</DetailText>
							</DetailItem>
							<DetailItem>
								<DetailIconContainer>
									<DetailIcon>
										<i className="fa-solid fa-clock" />
									</DetailIcon>
									<DetailLineContainer>
										<DetailLine>
											<line x1="50%" x2="50%" y1="1" y2="100%" />
										</DetailLine>
									</DetailLineContainer>
								</DetailIconContainer>
								<DetailText>
									<h3>{t('Hora')}</h3>
									<p>
										{WEDDING_DATE.setLocale(i18n.language).toLocaleString(
											DateTime.TIME_SIMPLE,
										)}
									</p>
								</DetailText>
							</DetailItem>
							<DetailItem>
								<DetailIconContainer>
									<DetailIcon>
										<i className="fa-solid fa-location-dot" />
									</DetailIcon>
								</DetailIconContainer>
								<DetailText>
									<h3>{t('Local da Cerimônia e Recepção')}</h3>
									<p>Espaco Di Trento</p>
									<p>Estr. p/ Pium, 214</p>
									<p>Nísia Floresta - RN, 59164-000</p>
									<p>{t('Brasil')}</p>
								</DetailText>
							</DetailItem>
						</VenueDetails>
					</VenueDetailsContainer>
				</VenueContainer>
			</div>
			<MapMarker ref={marker}>
				<MapMarkerIcon className="fa-solid fa-heart" />
			</MapMarker>
			<div style={{ height: '600px', width: '100%' }}>
				<div
					ref={mapContainer}
					className="map-container"
					style={{ height: '100%', width: '100%' }}
				/>
			</div>
		</VenueWrapper>
	)
}

export default Venue
